module.exports = __webpack_public_path__ + "img/GP.43fad009.svg";